export const POST_TRIAL = "post-trial";

export enum Plans {
  FREE_PLAN = "free-plan",
}
